import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { AuthorizationData } from '@kaseya-shared';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly httpBackend = inject(HttpBackend);
  private httpClientWithoutInterceptors: HttpClient;

  constructor() {
    this.httpClientWithoutInterceptors = new HttpClient(this.httpBackend);
  }

  refreshToken(refreshToken: string): Observable<AuthorizationData> {
    const url = 'api/v1/refresh-token';

    return this.httpClientWithoutInterceptors.post<AuthorizationData>(environment.portalApiUrl + url, {
      refreshToken,
    });
  }
}
